import React from "react";
import { CreateProfile } from "../../internal/CreateProfile/CreateProfile";
import { Header } from "../../internal/Header/Header";
import useUser from "../../../hooks/useUser";
import useIfLoggedIn from "../../../hooks/useIfLoggedIn";
import {
  Container,
  LeftPanel,
  ResponsiveImage,
  RightPanel,
  SignupContainer,
} from "../LoginPage";
import { Images } from "../../../assets/images";
import Footer from "../NewLandingPage/components/Footer";

const Index = () => {
  useIfLoggedIn();

  const { userObject } = useUser();
  // if (userObject?.name) {
  return (
    <>
      <Header>
        <Container>
          <LeftPanel>
            <SignupContainer>
              <CreateProfile
                message={`${userObject?.name} thanks for verifying your phone number. We need you to fill in a few more details in order to create you profile on IAMC`}
              />
            </SignupContainer>
          </LeftPanel>
          <RightPanel>
            <ResponsiveImage src={Images.Login} alt="create profile" />
          </RightPanel>
        </Container>
      </Header>
      <Footer />
    </>
  );
  // } else return null;
};

export default Index;
